import './device-detail.scss';
import React from 'react';
import moment from 'moment';
import {getExternalMapURL} from '../../../helpers/externalResources';
import {useIntl} from 'react-intl';
import {durationFormat} from '../../../helpers/date';

const formatTime = (tz, time) => time ?
                                  moment(time)
                                    .tz(tz)
                                    .format('YYYY-MM-DD HH:mm:ss') :
                                  '';

const Location = ({currentPosition, theme, timezone}) => {
  const intl = useIntl();
  return (
    <>
      <div className="section-container mt-3">
        <strong className="mb-1" style={{color: theme}}>
          {intl.formatMessage({id: 'deviceLastUpdate'})}
        </strong>
        <span className="text-gray">
          GPS: {currentPosition?.fixTime ? formatTime(timezone, currentPosition?.fixTime) : intl.formatMessage({id: 'notAvailable'})}
        </span>
        <span className="text-gray">
          {intl.formatMessage({id: 'deviceDeviceTime'})}: {currentPosition?.deviceTime ? formatTime(timezone, currentPosition?.deviceTime) : intl.formatMessage({id: 'notAvailable'})}
        </span>
        <span className="text-gray">
          {intl.formatMessage({id: 'deviceServerTime'})}: {currentPosition?.serverTime ? formatTime(timezone, currentPosition?.serverTime) : intl.formatMessage({id: 'notAvailable'})}
        </span>
        <span className="text-gray">
          {intl.formatMessage({id: 'deviceStoppedFor'})}: {currentPosition?.attributes?.stoppedTime != null ?
            durationFormat(currentPosition.attributes.stoppedTime, 'HH:mm:ss') :
            intl.formatMessage({id: 'notAvailable'})}
        </span>
      </div>
      <div className='section-container mt-3'>
        <div className='item-row item-space-between'>
          <div className='item-column'>
            <strong className="mb-1" style={{color: theme}}>{intl.formatMessage({id: 'sharedAddress'})}</strong>
            <span>{currentPosition?.address || intl.formatMessage({id: 'notAvailable'})}</span>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/images/street.png`}
            alt="street view"
            className="rounded-circle"
            onClick={() => {
              if (currentPosition?.latitude === undefined || currentPosition?.longitude === undefined) return;
              window.open(getExternalMapURL('street', currentPosition), '_blank');
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Location;
